import { type BaseTransfereeRepository } from "../../_Bases/BaseTransfereeRepository";
import { type LocalDatabaseTransferee } from "../../_Bases/BaseTransfereeRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBTransfereeRepository extends BaseIndexedDBRepository<
    LocalDatabaseTransferee
> implements BaseTransfereeRepository {
    public readonly source: InternalIndexedDBDatabase["transferees"];
    protected readonly dataTypeName = "Transferee";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.transferees;
    }

    public search(value: string): Promise<Array<LocalDatabaseTransferee>> {
        const needle = value.trim().toLowerCase();

        if(!needle) {
            return this.all();
        }

        return this.source
            .filter(transferee => {
                return transferee.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
